(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfcm-deal-calendar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var touch = matchMedia('(max-width: 1000px)');

  function init(sec) {
    if (sec.__bfcm) return;
    sec.__bfcm = true;
    var rows = sec.querySelectorAll('[data-deal]');
    var tiles = sec.querySelectorAll('[data-deal-tile]');
    var cap = sec.querySelector('[data-cap]');
    var path = sec.querySelector('[data-link-path]'), dotA = sec.querySelector('[data-link-a]'), dotB = sec.querySelector('[data-link-b]');
    var sheet = sec.querySelector('[data-sheet]');
    var active = null, pinned = null, leaveT = null, raf = 0;

    function row(d) { return sec.querySelector('[data-deal="' + d + '"]'); }
    function tile(d) { return sec.querySelector('[data-deal-tile="' + d + '"]'); }
    function capIdle() { return sec.getAttribute(touch.matches ? 'data-cap-tap' : 'data-cap-hover'); }

    function draw() {
      if (active === null) return;
      var r = row(active), t = tile(active);
      if (!r || !t) return;
      var o = sec.getBoundingClientRect(), rh = r.firstElementChild.getBoundingClientRect(), rr = r.getBoundingClientRect(), tb = t.getBoundingClientRect();
      var x1 = rr.right + 6 - o.left, y1 = rh.top + rh.height / 2 - o.top;
      var x2 = tb.left - 6 - o.left, y2 = tb.top + tb.height / 2 - o.top;
      var k = Math.max(40, (x2 - x1) * .5);
      path.setAttribute('d', 'M' + x1 + ' ' + y1 + ' C' + (x1 + k) + ' ' + y1 + ' ' + (x2 - k) + ' ' + y2 + ' ' + x2 + ' ' + y2);
      dotA.setAttribute('cx', x1); dotA.setAttribute('cy', y1);
      dotB.setAttribute('cx', x2); dotB.setAttribute('cy', y2);
    }
    // Rows animate open, so redraw every frame while a deal is active
    function loop() { draw(); raf = active === null ? 0 : requestAnimationFrame(loop); }

    function activate(d) {
      clearTimeout(leaveT);
      if (touch.matches || active === d) return;
      active = d;
      rows.forEach(function (x) { var on = x.getAttribute('data-deal') === d; x.classList.toggle('is-on', on); x.setAttribute('aria-expanded', String(on)); });
      tiles.forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-deal-tile') === d); });
      sec.classList.add('is-focus');
      var r = row(d);
      cap.textContent = r.getAttribute('data-name') + ', ' + r.getAttribute('data-date') + '. ' + r.getAttribute('data-opens') + '.';
      if (!raf) raf = requestAnimationFrame(loop);
    }
    function clear() {
      active = null;
      rows.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-expanded', 'false'); });
      tiles.forEach(function (x) { x.classList.remove('is-on'); });
      sec.classList.remove('is-focus');
      cap.textContent = capIdle();
    }
    function leave() { clearTimeout(leaveT); leaveT = setTimeout(function () { if (pinned !== null) activate(pinned); else clear(); }, 140); }
    function pin(d) { pinned = pinned === d ? null : d; if (pinned === null) clear(); else activate(d); }

    function openSheet(d) {
      var r = row(d);
      sheet.querySelector('[data-sheet-date]').textContent = r.getAttribute('data-date');
      sheet.querySelector('[data-sheet-title]').textContent = r.getAttribute('data-name');
      sheet.querySelector('[data-sheet-opens]').textContent = r.getAttribute('data-opens');
      sheet.querySelector('[data-sheet-note]').textContent = r.getAttribute('data-note');
      var box = sheet.querySelector('[data-sheet-prods]');
      box.innerHTML = '';
      box.appendChild(r.querySelector('template[data-sheet-prods]').content.cloneNode(true));
      sheet.showModal();
    }
    function choose(d) { if (touch.matches) openSheet(d); else pin(d); }

    function wire(el, d) {
      el.addEventListener('mouseenter', function () { activate(d); });
      el.addEventListener('focus', function () { activate(d); });
      el.addEventListener('blur', leave);
      el.addEventListener('click', function (e) { if (e.target.closest('a.bfcm-prod')) return; choose(d); });
    }
    rows.forEach(function (r) {
      var d = r.getAttribute('data-deal');
      wire(r, d);
      r.addEventListener('keydown', function (e) { if (e.target === r && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); choose(d); } });
    });
    tiles.forEach(function (t) { wire(t, t.getAttribute('data-deal-tile')); });
    sec.querySelector('.bfcm-cal__list').addEventListener('mouseleave', leave);
    sec.querySelector('.bfcm-cal__days').addEventListener('mouseleave', leave);
    document.addEventListener('click', function (e) { if (pinned !== null && !e.target.closest('[data-deal], [data-deal-tile]')) { pinned = null; clear(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && active !== null) { pinned = null; clear(); } });
    addEventListener('resize', draw);
    touch.addEventListener('change', function () { pinned = null; clear(); });

    sheet.querySelector('[data-sheet-close]').addEventListener('click', function () { sheet.close(); });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
    cap.textContent = capIdle();
  }

  function boot() { document.querySelectorAll('[data-bfcm-cal]').forEach(init); }
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-bfcm-cal]'); if (s) init(s); });
  document.addEventListener('shopify:block:select', function (e) {
    var r = e.target.closest && e.target.closest('[data-deal]');
    if (r) r.dispatchEvent(new MouseEvent('mouseenter'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfcm-deal-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function parse(v) { return v ? Date.parse(v.replace(/([+-]\d\d)(\d\d)$/, '$1:$2')) : NaN; }

  function init(root) {
    if (!root || root.hasAttribute('data-bdh-ready')) return;
    root.setAttribute('data-bdh-ready', '');
    var design = !!(window.Shopify && window.Shopify.designMode);
    var link = root.getAttribute('data-card-link');
    var now = Date.now();
    var q = /[?&]bfcm_now=([^&]+)/.exec(location.search);
    if (q) { var t = Date.parse(decodeURIComponent(q[1])); if (!isNaN(t)) now = t; }
    var early = false;
    try { early = localStorage.getItem('rg_bfcm_early') === '1'; } catch (e) {}

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bdh-card]'));
    var panels = root.querySelectorAll('[data-bdh-panel]');
    var live = [];
    cards.forEach(function (card) {
      var start = parse(card.getAttribute('data-start'));
      var ends = parse(card.getAttribute('data-ends'));
      var state = 'sealed';
      if (!isNaN(start)) {
        // The theme editor previews every card that has an entry.
        if (design || now >= start || (early && now >= start - 864e5)) state = 'live';
        if (state === 'live' && !design && !isNaN(ends) && now >= ends) state = 'ended';
      }
      card.setAttribute('data-state', state);
      card.disabled = state !== 'live';
      if (state === 'live') live.push(card);
    });

    function select(card) {
      cards.forEach(function (c) { c.setAttribute('aria-pressed', c === card ? 'true' : 'false'); });
      Array.prototype.forEach.call(panels, function (p) { p.hidden = p.getAttribute('data-bdh-panel') !== card.getAttribute('data-bdh-card'); });
    }
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.getAttribute('data-state') !== 'live') return;
        // The theme editor always switches, so every deal can be previewed.
        if (link && !design) window.location.href = link;
        else select(card);
      });
    });
    root._bdhSelect = function (id) {
      var card = root.querySelector('[data-bdh-card="' + id + '"]');
      if (card && card.getAttribute('data-state') === 'live') select(card);
    };

    if (live.length) {
      var current = live[live.length - 1];
      select(current);
      root.hidden = false;
      // On tablets and phones the row scrolls sideways: start it at the live deal.
      var row = current.parentNode;
      if (row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, current.offsetLeft - row.offsetLeft - 20);
    }
  }

  function initAll() { document.querySelectorAll('[data-bdh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-bdh]')); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-bdh]');
    if (root && root._bdhSelect) root._bdhSelect(e.detail.blockId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfcm-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'rg_bfcm_2026';
  var STAMP_MS = 950;

  function emailField(root) { return root.querySelector('input[type=email], input[name*=EMAIL i], input[name*=email i], input[id*=email i]'); }
  function phoneField(root) { return root.querySelector('input[type=tel], input[name*=SMS i], input[name*=phone i]'); }
  function optIn(root) { return root.querySelector('input[type=checkbox]'); }
  function alertsLabel(hero, form) {
    // SMS when the "receive text messages" box is ticked; forms without that box fall back to a filled phone number
    var p = phoneField(form), c = optIn(form);
    var both = c ? c.checked : !!(p && p.value.trim());
    return hero.getAttribute(both ? 'data-alerts-both' : 'data-alerts-email');
  }
  // Long addresses break before the @ rather than mid-word
  function setEmail(el, v) {
    var i = v.indexOf('@');
    el.textContent = i > 0 ? v.slice(0, i) : v;
    if (i > 0) el.append(document.createElement('wbr'), v.slice(i));
  }
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  function init(hero) {
    if (hero.__bfcm) return;
    hero.__bfcm = true;
    var form = hero.querySelector('[data-bfcm-form]');
    var cardEmail = hero.querySelector('[data-bfcm-card-email]');
    var cardAlerts = hero.querySelector('[data-bfcm-card-alerts]');
    var cardStatus = hero.querySelector('[data-bfcm-card-status]');

    // Live pass card: the email and alert type follow the form as it's filled in
    function syncCard() {
      var e = emailField(form), v = e ? e.value.trim() : '';
      setEmail(cardEmail, v || cardEmail.getAttribute('data-empty'));
      cardEmail.classList.toggle('is-empty', !v);
      cardAlerts.textContent = alertsLabel(hero, form);
    }
    form.addEventListener('input', syncCard);
    form.addEventListener('change', syncCard);

    // Every page load starts empty, even if the browser tries to restore typed values
    function clearForm() {
      form.querySelectorAll('input').forEach(function (i) {
        if (i.type === 'checkbox' || i.type === 'radio') i.checked = false;
        else if (i.type !== 'hidden' && i.type !== 'submit' && i.type !== 'button') i.value = '';
      });
      cardStatus.textContent = hero.getAttribute('data-status-off');
      hero.classList.remove('is-stamping');
      syncCard();
    }
    // (no clear on window load: someone may already be typing on a slow page)
    clearForm();

    // Issued pass: filled from the stored sign-up
    function fillPass(data) {
      data = data || {};
      setEmail(hero.querySelector('[data-bfcm-pass-email]'), data.email || '');
      var alerts = data.alerts || hero.getAttribute('data-alerts-email');
      hero.querySelector('[data-bfcm-pass-alerts]').textContent = alerts;
      var both = alerts === hero.getAttribute('data-alerts-both');
      hero.querySelectorAll('[data-bfcm-step]').forEach(function (el) {
        el.textContent = el.getAttribute(both ? 'data-text-both' : 'data-text-email');
      });
    }
    document.addEventListener('bfcm:state', function (e) {
      if (e.detail.registered) fillPass(e.detail.data);
      else clearForm();
    });
    if (window.BFCM && window.BFCM.state) fillPass(window.BFCM.state);

    // Sign-up success: the seal stamps the card, then the pass is issued
    var pending = null, watching = null, submittedField = null;
    function succeed() {
      if (!pending || hero.classList.contains('is-stamping')) return;
      if (watching) watching.disconnect();
      cardStatus.textContent = hero.getAttribute('data-status-on');
      hero.classList.add('is-stamping');
      setTimeout(function () {
        window.BFCM.register(pending);
        window.BFCM.scrollTo(hero);
      }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : STAMP_MS);
    }
    // PushOwl (Brevo block) re-renders to its next step on success, so the email field disappears
    function formMovedOn() { return submittedField && !submittedField.isConnected && !emailField(form); }
    function looksLikeSuccess(node) {
      if (!(node instanceof Element)) return false;
      var hit = node.matches('#success-message, [class*=success], [id*=success]') ? node : node.querySelector('#success-message, [class*=success], [id*=success]');
      return !!(hit && visible(hit) && hit.textContent.trim());
    }
    form.addEventListener('submit', function () {
      var e = emailField(form);
      submittedField = e;
      pending = { email: e ? e.value.trim() : '', alerts: alertsLabel(hero, form) };
      try { sessionStorage.setItem(KEY + '_pending', JSON.stringify(pending)); } catch (err) {}
      if (watching) watching.disconnect();
      watching = new MutationObserver(function (records) {
        if (formMovedOn()) return succeed();
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          if (looksLikeSuccess(r.target)) return succeed();
          for (var j = 0; j < r.addedNodes.length; j++) if (looksLikeSuccess(r.addedNodes[j])) return succeed();
        }
      });
      watching.observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      setTimeout(function () { if (watching) watching.disconnect(); }, 20000);
    }, true);

    // Share menu: each platform's public share link, copy link, and the phone's share sheet. No API keys.
    var toggle = hero.querySelector('[data-bfcm-share-toggle]');
    if (toggle) {
      var menu = hero.querySelector('[data-bfcm-share-menu]');
      var url = hero.getAttribute('data-share-url') || location.href.split('#')[0].split('?')[0];
      var msg = hero.getAttribute('data-share-text') || '';
      var subject = document.title;
      var enc = encodeURIComponent;
      var links = {
        whatsapp: 'https://wa.me/?text=' + enc(msg + ' ' + url),
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + enc(url),
        x: 'https://twitter.com/intent/tweet?text=' + enc(msg) + '&url=' + enc(url),
        threads: 'https://www.threads.net/intent/post?text=' + enc(msg + ' ' + url),
        pinterest: 'https://pinterest.com/pin/create/button/?url=' + enc(url) + '&description=' + enc(msg),
        linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + enc(url),
        sms: 'sms:?&body=' + enc(msg + ' ' + url),
        email: 'mailto:?subject=' + enc(subject) + '&body=' + enc(msg + '\n\n' + url)
      };
      menu.querySelectorAll('[data-net]').forEach(function (a) { a.href = links[a.getAttribute('data-net')]; });
      var field = menu.querySelector('[data-bfcm-share-url]'), copy = menu.querySelector('[data-bfcm-copy]'), native = menu.querySelector('[data-bfcm-share-native]');
      field.value = url;
      if (navigator.share) native.hidden = false;
      function open(on) {
        menu.hidden = !on;
        toggle.setAttribute('aria-expanded', String(on));
        if (on) menu.querySelector('[data-net]').focus();
      }
      toggle.addEventListener('click', function () { open(menu.hidden); });
      document.addEventListener('click', function (e) { if (!menu.hidden && !e.target.closest('.bfcm-share')) open(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { open(false); toggle.focus(); } });
      var label = copy.textContent;
      copy.addEventListener('click', function () {
        var done = function () {
          copy.textContent = copy.getAttribute('data-done'); copy.classList.add('is-done');
          setTimeout(function () { copy.textContent = label; copy.classList.remove('is-done'); }, 2000);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { field.select(); document.execCommand('copy'); done(); });
        else { field.select(); document.execCommand('copy'); done(); }
      });
      native.addEventListener('click', function () { navigator.share({ title: subject, text: msg, url: url }).catch(function () {}); });
    }

  }

  function boot() { document.querySelectorAll('[data-bfcm-hero]').forEach(init); }
  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector('[data-bfcm-hero]');
    if (!hero) return;
    init(hero);
    if (window.BFCM) BFCM.syncPreview();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boule-intent"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBouleIntent(root) {
    if (!root || root.dataset.biInit === '1') return;
    root.dataset.biInit = '1';

    var overlay = root.querySelector('[data-bi-overlay]');
    var dialog = root.querySelector('[data-bi-dialog]');
    var panel = root.querySelector('[data-bi-panel]');
    var mediaImg = root.querySelector('.boule-intent__media-img');
    var nameEl = root.querySelector('[data-bi-name]');
    var capEl = root.querySelector('[data-bi-cap]');
    var openBtn = root.querySelector('[data-bi-open]');
    var closeBtn = root.querySelector('[data-bi-close]');
    var looksTag = root.querySelector('[data-bi-looks]');
    if (!overlay || !panel) return;

    var radioField = root.getAttribute('data-radio-field') || 'custom#products';
    var looks = [];
    try { looks = JSON.parse(looksTag.textContent) || []; } catch (e) { looks = []; }

    var formSlot = root.querySelector('[data-bi-form-slot]');
    var lastFocus = null;

    // Reflect look[index] into the modal's left media.
    function applyLook(index) {
      var look = looks[index];
      if (!look) return;
      if (mediaImg && look.img) {
        // The img is rendered with a srcset (via image_tag); a browser prefers
        // srcset over src, so we must drop srcset for the new src to render.
        mediaImg.removeAttribute('srcset');
        mediaImg.removeAttribute('sizes');
        mediaImg.setAttribute('src', look.img);
        mediaImg.setAttribute('alt', look.alt || '');
      }
      if (nameEl) nameEl.textContent = look.label || '';
      if (capEl) capEl.textContent = look.caption || '';
    }

    function escName() {
      return (window.CSS && CSS.escape) ? CSS.escape(radioField) : radioField;
    }

    // --- Shadow-DOM form wiring --------------------------------------------
    // The Shopify Forms form renders inside an OPEN shadow root. Rather than
    // depend on events crossing that boundary, we reach in directly once it
    // hydrates: inject pill styling for the radios, attach change listeners so
    // the left image swaps, and pre-select the first look. CSS custom
    // properties (var(--biAccent)) inherit across the boundary, so the injected
    // style stays on-brand.
    var RADIO_CSS =
      'fieldset[name="' + radioField + '"] > div{display:flex;flex-direction:column;gap:8px;align-items:flex-start;}' +
      'fieldset[name="' + radioField + '"] label{box-sizing:border-box;display:flex;align-items:center;width:fit-content;margin:0;border:1px solid rgba(28,28,28,.2);border-radius:12px;padding:11px 16px;cursor:pointer;transition:border-color .18s ease,background .18s ease,color .18s ease;}' +
      'fieldset[name="' + radioField + '"] input[type="radio"]{position:absolute;opacity:0;width:0;height:0;}' +
      'fieldset[name="' + radioField + '"] label:hover{border-color:var(--biAccent);}' +
      'fieldset[name="' + radioField + '"] label:has(input:checked){background:var(--biAccent);border-color:var(--biAccent);}' +
      'fieldset[name="' + radioField + '"] label:has(input:checked) span{color:#fff;}' +
      'fieldset[name="' + radioField + '"] legend{margin-bottom:9px;}';

    function formShadow() {
      var host = (formSlot && formSlot.querySelector('shopify-forms-embed'))
        || document.querySelector('shopify-forms-embed');
      return host && host.shadowRoot ? host.shadowRoot : null;
    }

    function productRadios() {
      var sr = formShadow();
      return sr ? sr.querySelectorAll('input[type="radio"][name="' + escName() + '"]') : [];
    }

    // Reliable swap: while the modal is open, poll which radio is checked and
    // reflect it into the media. Reading state can't be blocked by the app's
    // event handling / React re-renders the way a change listener can.
    var pollTimer = null;
    var lastIdx = -1;
    function pollSelection() {
      var radios = productRadios();
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) {
          if (i !== lastIdx) { lastIdx = i; applyLook(i); }
          return;
        }
      }
    }
    function startPolling() {
      stopPolling();
      lastIdx = -1;
      pollSelection();
      pollTimer = setInterval(pollSelection, 150);
    }
    function stopPolling() {
      if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
    }

    // Handle a radio change inside the shadow tree → swap the left image.
    // Listens on the shadow ROOT (not each radio) so it survives the app's
    // React re-renders, which replace the radio nodes. 'change' bubbles up to
    // the shadow root (it just doesn't cross out of it), and within one shadow
    // tree the event isn't retargeted, so e.target is the actual radio.
    function onShadowChange(sr, e) {
      var t = e.target;
      if (!t || t.tagName !== 'INPUT' || t.type !== 'radio' || t.name !== radioField || !t.checked) return;
      var group = sr.querySelectorAll('input[type="radio"][name="' + escName() + '"]');
      var idx = Array.prototype.indexOf.call(group, t);
      if (idx > -1) applyLook(idx);
    }

    // Inject pill CSS, bind the delegated listener, and default-select look 1.
    // Returns true once the form is present and wired.
    function wireForm() {
      var sr = formShadow();
      if (!sr) return false;
      var radios = sr.querySelectorAll('input[type="radio"][name="' + escName() + '"]');
      if (!radios.length) return false;

      if (!sr.querySelector('#bi-radio-style')) {
        var st = document.createElement('style');
        st.id = 'bi-radio-style';
        st.textContent = RADIO_CSS;
        sr.appendChild(st);
      }

      // One delegated listener per shadow root (guarded), so re-renders can't
      // detach it. 'change' fires on select; 'input' is a belt-and-suspenders.
      if (!sr._biBound) {
        sr._biBound = true;
        var handler = function (e) { onShadowChange(sr, e); };
        sr.addEventListener('change', handler);
        sr.addEventListener('input', handler);
      }

      // Keep the first look selected by default (visually + in the form state).
      var anyChecked = Array.prototype.some.call(radios, function (r) { return r.checked; });
      if (!anyChecked) {
        radios[0].checked = true;
        radios[0].dispatchEvent(new Event('input', { bubbles: true }));
        radios[0].dispatchEvent(new Event('change', { bubbles: true }));
        applyLook(0);
      }
      return true;
    }

    // The app hydrates the form asynchronously — poll briefly until it's ready.
    var wireTimer = null;
    function wireFormSoon() {
      var tries = 40;
      if (wireTimer) { clearTimeout(wireTimer); wireTimer = null; }
      (function poll() {
        if (wireForm() || --tries <= 0) { wireTimer = null; return; }
        wireTimer = setTimeout(poll, 200);
      })();
    }

    // --- Form reset ---------------------------------------------------------
    // Read the Shopify Forms step from its open shadow root.
    function formStep() {
      try {
        var sr = formShadow();
        var stepEl = sr && sr.querySelector('[data-current-step]');
        return stepEl ? stepEl.getAttribute('data-current-step') : null;
      } catch (e) { return null; }
    }
    function formSubmitted() {
      var step = formStep();
      return !!step && step !== 'form';
    }
    // Shopify Forms renders once on page load and offers no client-side reset —
    // after a submit it holds the success state and re-rendering it via the DOM
    // just yields a blank box. The one reliable way to a fresh form is a page
    // load, so if the modal is reopened after a submission we reload once (with
    // a flag) and auto-reopen. Loop-guarded via reopenedAfterReset.
    var RESET_KEY = 'biReopen-' + (root.getAttribute('data-section-id') || '');
    var reopenedAfterReset = false;
    try {
      if (sessionStorage.getItem(RESET_KEY)) {
        sessionStorage.removeItem(RESET_KEY);
        reopenedAfterReset = true;
      }
    } catch (e) {}

    wireFormSoon();

    function getFocusable() {
      return dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
    }

    function openModal() {
      // If the form was already submitted this pageview, reload once to get a
      // fresh one, then auto-reopen (see reset notes above).
      if (formSubmitted() && !reopenedAfterReset) {
        try { sessionStorage.setItem(RESET_KEY, '1'); } catch (e) {}
        location.reload();
        return;
      }
      wireFormSoon();
      applyLook(0);
      lastFocus = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      startPolling();
      var f = getFocusable();
      (f.length ? f[0] : closeBtn || dialog).focus();
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      stopPolling();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKeydown(e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'Tab') {
        var f = getFocusable();
        // If the form renders in shadow DOM we can only see the close button.
        // Don't trap on a single element — let native tabbing reach the form.
        if (f.length < 2) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    if (openBtn) openBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    document.addEventListener('keydown', onKeydown);

    // Came back from a reset reload → reopen the (now fresh) modal.
    if (reopenedAfterReset) { setTimeout(openModal, 60); }

    root._biCleanup = function () {
      document.removeEventListener('keydown', onKeydown);
      document.body.style.overflow = '';
      stopPolling();
      if (wireTimer) { clearTimeout(wireTimer); wireTimer = null; }
    };
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="boule-intent"]').forEach(initBouleIntent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-section-type="boule-intent"]');
    if (root) initBouleIntent(root);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-section-type="boule-intent"]');
    if (root && root._biCleanup) root._biCleanup();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SELECTOR = '[data-section-type="event-countdown"]';

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function EventCountdown(root) {
    this.root = root;
    this.counting = root.querySelector('[data-ec-counting]');
    this.live = root.querySelector('[data-ec-live]');
    this.elDays = root.querySelector('[data-ec-days]');
    this.elHours = root.querySelector('[data-ec-hours]');
    this.elMinutes = root.querySelector('[data-ec-minutes]');
    this.elSeconds = root.querySelector('[data-ec-seconds]');
    this.canvas = root.querySelector('.event-countdown__confetti');

    var iso = root.getAttribute('data-target-epoch');
    this.target = iso ? Date.parse(iso) : NaN;

    this.interval = null;
    this.raf = null;
    this.observer = null;
    this.confettiRunning = false;
    this.particles = [];
    this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.colors = (root.getAttribute('data-confetti-colors') || '')
      .split(',').map(function (c) { return c.trim(); }).filter(Boolean);
    if (!this.colors.length) this.colors = ['#F4B8C5', '#3f7d1e', '#e8c26a', '#ffffff'];
    this.density = parseInt(root.getAttribute('data-confetti-density'), 10) || 60;

    this.onResize = this.resizeCanvas.bind(this);
    this.init();
  }

  EventCountdown.prototype.init = function () {
    var mode = 'auto';
    if (window.Shopify && window.Shopify.designMode) {
      mode = this.root.getAttribute('data-preview-state') || 'auto';
    }

    if (mode === 'live') { this.showLive(); return; }
    if (mode === 'counting') { this.showCounting(); this.tick(); return; }

    // Auto: decide from the real target instant.
    if (isNaN(this.target) || Date.now() >= this.target) {
      this.showLive();
    } else {
      this.showCounting();
      this.tick();
      var self = this;
      this.interval = setInterval(function () { self.tick(); }, 1000);
    }
  };

  EventCountdown.prototype.showCounting = function () {
    this.counting.hidden = false;
    this.live.hidden = true;
  };

  EventCountdown.prototype.showLive = function () {
    this.counting.hidden = true;
    this.live.hidden = false;
    this.startConfetti();
  };

  EventCountdown.prototype.tick = function () {
    if (isNaN(this.target)) return;
    var diff = this.target - Date.now();
    if (diff <= 0) {
      if (this.interval) { clearInterval(this.interval); this.interval = null; }
      this.setDigits(0, 0, 0, 0);
      this.showLive();
      return;
    }
    var totalSeconds = Math.floor(diff / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    this.setDigits(days, hours, minutes, seconds);
  };

  EventCountdown.prototype.setDigits = function (d, h, m, s) {
    if (this.elDays) this.elDays.textContent = d < 100 ? pad(d) : String(d);
    if (this.elHours) this.elHours.textContent = pad(h);
    if (this.elMinutes) this.elMinutes.textContent = pad(m);
    if (this.elSeconds) this.elSeconds.textContent = pad(s);
  };

  /* ---------- Confetti ---------- */

  EventCountdown.prototype.startConfetti = function () {
    if (!this.canvas || this.confettiRunning) return;
    this.confettiRunning = true;
    this.canvas.hidden = false;
    this.ctx = this.canvas.getContext('2d');
    this.resizeCanvas();
    this.seedParticles();
    window.addEventListener('resize', this.onResize);

    if (this.reduceMotion) {
      this.drawFrame(); // one static settled frame
      return;
    }

    var self = this;
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) self.play(); else self.pause();
        });
      }, { threshold: 0 });
      this.observer.observe(this.root);
    } else {
      this.play();
    }
  };

  EventCountdown.prototype.resizeCanvas = function () {
    var rect = this.root.getBoundingClientRect();
    var dpr = window.devicePixelRatio || 1;
    this.w = Math.max(1, Math.round(rect.width));
    this.h = Math.max(1, Math.round(rect.height));
    this.canvas.width = this.w * dpr;
    this.canvas.height = this.h * dpr;
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };

  EventCountdown.prototype.seedParticles = function () {
    var count = Math.max(12, Math.min(200, this.density));
    this.particles = [];
    for (var i = 0; i < count; i++) {
      this.particles.push(this.makeParticle(true));
    }
  };

  // Deterministic pseudo-random per particle index avoids reliance on any
  // single Math.random hotspot; Math.random is fine to use in the browser.
  EventCountdown.prototype.makeParticle = function (spread) {
    var size = 5 + Math.random() * 7;
    return {
      x: Math.random() * this.w,
      y: spread ? Math.random() * this.h : -size - Math.random() * this.h * 0.3,
      size: size,
      color: this.colors[Math.floor(Math.random() * this.colors.length)],
      angle: Math.random() * Math.PI * 2,
      spin: (Math.random() - 0.5) * 0.12,
      vy: 0.4 + Math.random() * 0.9,
      sway: 0.4 + Math.random() * 0.8,
      swayPhase: Math.random() * Math.PI * 2,
      swaySpeed: 0.01 + Math.random() * 0.02
    };
  };

  EventCountdown.prototype.drawFrame = function () {
    var ctx = this.ctx;
    ctx.clearRect(0, 0, this.w, this.h);
    for (var i = 0; i < this.particles.length; i++) {
      var p = this.particles[i];
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.angle);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
      ctx.restore();
    }
  };

  EventCountdown.prototype.step = function () {
    for (var i = 0; i < this.particles.length; i++) {
      var p = this.particles[i];
      p.swayPhase += p.swaySpeed;
      p.x += Math.sin(p.swayPhase) * p.sway;
      p.y += p.vy;
      p.angle += p.spin;
      if (p.y - p.size > this.h) {
        this.particles[i] = this.makeParticle(false);
      }
    }
    this.drawFrame();
    this.raf = window.requestAnimationFrame(this.step.bind(this));
  };

  EventCountdown.prototype.play = function () {
    if (this.reduceMotion || this.raf) return;
    this.raf = window.requestAnimationFrame(this.step.bind(this));
  };

  EventCountdown.prototype.pause = function () {
    if (this.raf) { window.cancelAnimationFrame(this.raf); this.raf = null; }
  };

  EventCountdown.prototype.destroy = function () {
    if (this.interval) { clearInterval(this.interval); this.interval = null; }
    this.pause();
    if (this.observer) { this.observer.disconnect(); this.observer = null; }
    window.removeEventListener('resize', this.onResize);
    this.confettiRunning = false;
  };

  var instances = {};

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var id = root.getAttribute('data-section-id');
      if (instances[id]) instances[id].destroy();
      instances[id] = new EventCountdown(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector(SELECTOR);
    if (!root) return;
    var id = root.getAttribute('data-section-id');
    if (instances[id]) instances[id].destroy();
    instances[id] = new EventCountdown(root);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector(SELECTOR);
    if (!root) return;
    var id = root.getAttribute('data-section-id');
    if (instances[id]) { instances[id].destroy(); delete instances[id]; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["the-details"] && !Shopify.designMode) return;
  try {
    
  class TheDetails extends HTMLElement {
    constructor() {
      super();
      this.mqMobile = window.matchMedia('(max-width: 769px)');
      this.activeIndex = 0;
      this._onResize = this._onResize.bind(this);
      this._onBlockSelect = this._onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.the-details__tab'));
      this.headers = Array.from(this.querySelectorAll('.the-details__acc-header'));
      this.panels = Array.from(this.querySelectorAll('.the-details__panel-content'));
      if (!this.panels.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.setActive(this._idx(tab)));
        tab.addEventListener('keydown', (e) => this._onTabKeydown(e));
      });
      this.headers.forEach((header) => {
        header.addEventListener('click', () => this.toggle(this._idx(header)));
      });

      this.mqMobile.addEventListener('change', this._onResize);
      document.addEventListener('shopify:block:select', this._onBlockSelect);

      this._render(false);
    }

    disconnectedCallback() {
      this.mqMobile.removeEventListener('change', this._onResize);
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
    }

    isMobile() {
      return this.mqMobile.matches;
    }

    _idx(el) {
      return parseInt(el.dataset.index, 10);
    }

    setActive(i) {
      this.activeIndex = i;
      this._render(true);
    }

    toggle(i) {
      this.activeIndex = this.activeIndex === i ? null : i;
      this._render(true);
    }

    _onResize() {
      if (!this.isMobile() && this.activeIndex == null) this.activeIndex = 0;
      this._render(false);
    }

    _onBlockSelect(e) {
      const el = e.target.closest && e.target.closest('[data-index]');
      if (!el || !this.contains(el)) return;
      const i = this._idx(el);
      if (Number.isNaN(i)) return;
      this.activeIndex = i;
      this._render(true);
    }

    _onTabKeydown(e) {
      const current = this.tabs.indexOf(document.activeElement);
      if (current < 0) return;
      let next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (current + 1) % this.tabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (current - 1 + this.tabs.length) % this.tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = this.tabs.length - 1;
      if (next === null) return;
      e.preventDefault();
      this.setActive(next);
      this.tabs[next].focus();
    }

    _render(animate) {
      this.tabs.forEach((tab, i) => {
        const active = i === this.activeIndex;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      this.headers.forEach((header, i) => {
        header.setAttribute('aria-expanded', i === this.activeIndex ? 'true' : 'false');
      });
      this.panels.forEach((panel, i) => {
        const active = i === this.activeIndex;
        panel.hidden = !active;
        if (active) {
          if (animate) {
            panel.classList.remove('is-active');
            void panel.offsetWidth; // force reflow so the animation replays
          }
          panel.classList.add('is-active');
        } else {
          panel.classList.remove('is-active');
        }
      });
    }
  }

  if (!customElements.get('the-details')) {
    customElements.define('the-details', TheDetails);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel-heading"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SECTION_SEL = '[data-section-type="video-carousel-heading"]';
  /* A real Whatmore tile only exists once a video has rendered. Keying off a
     <video> in the carousel slot is template-agnostic (works for template-g/h
     and survives Whatmore markup changes); the others are belt-and-braces. */
  var VIDEO_SEL = '.vch-carousel video, [aria-label^="Play video"], .whatmore-video-player-muted';
  var WAIT_MS = 5000;

  function inDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function hasVideos(root) {
    return !!root.querySelector(VIDEO_SEL);
  }

  function reveal(root) {
    root.classList.remove('vch--pending');
    root.classList.add('vch--ready');
  }

  function collapse(root) {
    // Never hide in the editor — the merchant must be able to select it.
    if (inDesignMode()) { reveal(root); return; }
    var sec = root.closest ? root.closest('.shopify-section') : null;
    (sec || root).style.display = 'none';
  }

  function init(root) {
    if (!root || root.dataset.vchInit === '1') { return; }
    root.dataset.vchInit = '1';

    if (inDesignMode()) { reveal(root); return; }
    if (root.getAttribute('data-hide-when-empty') !== 'true') { reveal(root); return; }
    if (hasVideos(root)) { reveal(root); return; }

    var carousel = root.querySelector('.vch-carousel') || root;
    var done = false;
    var observer = new MutationObserver(function () {
      if (hasVideos(root)) { settle(true); }
    });
    var timer = null;
    var io = null;

    function settle(found) {
      if (done) { return; }
      done = true;
      observer.disconnect();
      if (io) { io.disconnect(); }
      if (timer) { clearTimeout(timer); }
      if (found) { reveal(root); } else { collapse(root); }
    }

    function startWatching() {
      if (timer) { return; }
      observer.observe(carousel, { childList: true, subtree: true });
      timer = setTimeout(function () { settle(hasVideos(root)); }, WAIT_MS);
    }

    /* Whatmore lazy-loads, so don't judge it "empty" before it's near view. */
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { startWatching(); break; }
        }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else {
      startWatching();
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll(SECTION_SEL);
    for (var i = 0; i < nodes.length; i++) { init(nodes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-event-highlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  var FOCUSABLE = 'button, [href], video, [tabindex]:not([tabindex="-1"])';

  function lockScroll(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
    document.body.style.overflow = on ? 'hidden' : '';
  }

  function bind(section) {
    if (!section || section.dataset.vehBound === 'true') return;
    var trigger = section.querySelector('[data-veh-open]');
    var modal = section.querySelector('[data-veh-modal]');
    if (!trigger || !modal) return;

    var video = modal.querySelector('.veh-modal__video');
    var closers = modal.querySelectorAll('[data-veh-close]');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      lockScroll(true);
      if (video) { try { video.play(); } catch (e) {} }
      var closeBtn = modal.querySelector('.veh-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (modal.hidden) return;
      if (video) { video.pause(); try { video.currentTime = 0; } catch (e) {} }
      modal.hidden = true;
      lockScroll(false);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var items = modal.querySelectorAll(FOCUSABLE);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    trigger.addEventListener('click', open);
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);
    document.addEventListener('keydown', onKeydown);

    // Expose a closer so section:unload can tidy up.
    section._vehClose = close;
    section.dataset.vehBound = 'true';
  }

  // The CTA opens the Boulé Intent section's existing form modal (that section
  // owns the modal + Shopify Forms block). We simply forward the click to its
  // open trigger, so the intent modal's own logic runs unchanged. No-ops if
  // that section (or its trigger) isn't on the page.
  function bindIntentCta(section) {
    if (!section || section.dataset.vehCtaBound === 'true') return;
    var trigger = section.querySelector('[data-veh-open-intent]');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var opener = document.querySelector('[data-section-type="boule-intent"] [data-bi-open]');
      if (opener) opener.click();
    });
    section.dataset.vehCtaBound = 'true';
  }

  function init(scope) {
    var sections = (scope || document).querySelectorAll('[data-section-type="video-event-highlight"]');
    for (var i = 0; i < sections.length; i++) { bind(sections[i]); bindIntentCta(sections[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-section-type="video-event-highlight"]')) {
      init(e.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target && e.target.querySelector ? e.target.querySelector('[data-section-type="video-event-highlight"]') : null;
    if (section && typeof section._vehClose === 'function') section._vehClose();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
